const colors = {
    color_nokia_white: '#FFFFFF',
    color_nokia_blue: '#124191',
    color_nokia_blue_dark: '#02135',

    color_nokia_neutral_lighter: '#EDF2F5',
    color_nokia_neutral_light: '#BEC8D2',
    color_nokia_neutral_medium: '#98A2AE',
    color_nokia_neutral_dark: '#4D5766',
    color_nokia_neutral_darker: '#273142',

    color_nokia_secondary_yellow: '#FFFB00',
    color_nokia_secondary_red: '#FF3154',
    color_nokia_secondary_orange: '#FF8B10',
    color_nokia_secondary_green: '#4BDD33',
    color_nokia_secondary_blue: '#00C9FF',

    color_nokia_app_blue_light: '#00C9FF',
    color_nokia_app_blue: '#0E97F5',
    color_nokia_app_mint: '#00E88E'
}

const structure = {
    menuComponent: () => import('@/core/components/Menu.vue'),
    overlayComponent: () => import('@/core/components/Overlay.vue'),
    settings: {
        disableStructureDefaultsWarnings: true,
        disableNavigationDebugLogging: true,
        width: 1920,
        height: 1080,
        slideTransitionSpeed: .4,
        keyframeTransition: false,
        bodyBackgroundColor: "black",
        demoBackgroundColor: colors.color_nokia_neutral_lighter,
        presentationBackgroundColor: colors.color_nokia_neutral_lighter,
        chapterBackgroundColor: colors.color_nokia_neutral_lighter,
        slideBackgroundColor: "none",
        keyframeBackgroundColor: "none",
        menuCloseOnNavigation: true,
        menuPositionRight: true,
        menuHideSlideProgress: false,
        menuHideKeyframeProgress: false,
        menuDark: true,
        navigationBackEnterFirstKeyframe: false,
        navigationBackEnterFirstSlide: false,
        navigationCustomTitleBackKeyframe: false,
        navigationCustomTitleBackSlide: false,
        navigationCustomTitleBackChapter: false,
        navigationCustomTitleNextKeyframe: false,
        navigationCustomTitleNextSlide: false,
        navigationCustomTitleNextChapter: false,
        navigationButtonTitleRestart: false,
        enableKeyboardNavigation: false,
        enableKeyboardChapterUpDown: false,
        enableMenuHotkeys: false,
        showMenuHotkeys: false,
        hotKeyNext: false,
        hotKeyMenu: " ",
        hotKeyRestart: "Escape",
        screenSaver: [],
        screenSaverEnabled: true,
        screenSaverDelaySeconds: 30,
        screenSaverHotKey: "Enter"
    },
    overlays: [
        { uri: "overlay-1", title: "Overlay 1", content: {component: () => import('@/demo/OverlayExample.vue')} }
    ],
    presentations: [
        {
            title: "Nokia ",
            subtitle: "Network Exposure Function",
            chapters: [
                // {
                //     title: "IoT smart agriculture",
                //     uri: 'iot-smart-agriculture',
                //     foreground: { component: () => import("@/demo/components/CommentOverlay.vue") },
                //     slides: [
                //         {
                //             title: "IoT smart agriculture",
                //             uri: 'use-case',
                //             // links: [{ title: 'Overlay', overlay: 'overlay-1' }],
                //             keyframes: [
                //                 {
                //                     uri: '01',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-1/usecase_agri-culture_01.mp4"), poster: require("@/demo/assets/images/poster/usecase-1/usecase_agri-culture_01.jpg"), continueOnEnd: false } },
                //                     comment: 'The drone measures plant health and recognizes plant pests. It records and actualizes geographical data of the area. Intelligent smart agriculture applications measure the drone’s battery parameters, bandwidth and latency information continuously. It checks for bandwidth allocation for HQ video streaming.'
                //                 },{
                //                     uri: '02',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-1/usecase_agri-culture_02.mp4"), poster: require("@/demo/assets/images/poster/usecase-1/usecase_agri-culture_02.jpg"), continueOnEnd: false } },
                //                     comment: 'To identify the pests the video stream delivered by the drone needs to be in high resolution. The re-allocated UPF guarantees to maintain latency and bandwidth.',
                //                 },{
                //                     uri: '03',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-1/usecase_agri-culture_03.mp4"), poster: require("@/demo/assets/images/poster/usecase-1/usecase_agri-culture_03.jpg"), continueOnEnd: false } },
                //                     comment: 'Thousands of 5G connected IoT sensors are placed in throughout the fields​. Many sensors remain idle to save bandwidth and battery life.​',
                //                 },{
                //                     uri: '04',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-1/usecase_agri-culture_04.mp4"), poster: require("@/demo/assets/images/poster/usecase-1/usecase_agri-culture_04.jpg"), continueOnEnd: false } },
                //                     comment: 'NEF fetches weather information from 3rd party data sources. The Sensors are programmed to wake up every 24 hours. NEF will adjust the activity schedule based upon the predeicted event.​',
                //                 },{
                //                     uri: '05',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-1/usecase_agri-culture_05.mp4"), poster: require("@/demo/assets/images/poster/usecase-1/usecase_agri-culture_05.jpg"), continueOnEnd: false } },
                //                     comment: 'Due to weather change more frequent sampling is programmed to sensors. This weather condition requires more accuracy in measurement which overrules battery saving parameters.',
                //                 },{
                //                     uri: '06',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-1/usecase_agri-culture_06.mp4"), poster: require("@/demo/assets/images/poster/usecase-1/usecase_agri-culture_06.jpg"), continueOnEnd: false } },
                //                 }
                //             ],
                //         },
                //     ]
                // },
                // {
                //     title: "Consumer gaming",
                //     uri: 'consumer-gaming',
                //     foreground: { component: () => import("@/demo/components/CommentOverlay.vue") },
                //     slides: [
                //         {
                //             title: "Consumer gaming",
                //             uri: 'use-case',
                //             // links: [{ title: 'Overlay', overlay: 'overlay-1' }],
                //             keyframes: [
                //                 {
                //                     uri: '01',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-2/usecase_ar-game_01.mp4"), poster: require("@/demo/assets/images/poster/usecase-2/usecase_ar-game_01.jpg"), continueOnEnd: false } },
                //                     comment: 'The gamer is on the move. AR objects are well scattered geographically. By approaching the closest edge, the hosted gaming application re-allocation is triggered to maintain the game’s basic latency and bandwidth parameters. The application re-allocation causes no interruption in the game.​',
                //                 },{
                //                     uri: '02',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-2/usecase_ar-game_02.mp4"), poster: require("@/demo/assets/images/poster/usecase-2/usecase_ar-game_02.jpg"), continueOnEnd: false } },
                //                     comment: 'The AR event is triggered. The gaming application requires higher bandwidth and lower latency from the 5G network through NEF for the duration of AR event.',
                //                 },{
                //                     uri: '03',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-2/usecase_ar-game_03.mp4"), poster: require("@/demo/assets/images/poster/usecase-2/usecase_ar-game_03.jpg"), continueOnEnd: false } },
                //                     comment: 'High bandwidth and low latency is provisioned for the duration of the AR event.',
                //                 },{
                //                     uri: '04',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-2/usecase_ar-game_04.mp4"), poster: require("@/demo/assets/images/poster/usecase-2/usecase_ar-game_04.jpg"), continueOnEnd: false } },
                //                     comment: 'The gamer has won and the AR event is over. The normal connectivity specifications are restord based on the gamer’s subscribtion.',
                //                 },{
                //                     uri: '05',
                //                     content: { video: { src: require("@/demo/assets/videos/usecase-2/usecase_ar-game_05.mp4"), poster: require("@/demo/assets/images/poster/usecase-2/usecase_ar-game_05.jpg"), continueOnEnd: false } },
                //                 }
                //             ],
                //         },
                //     ]
                // },
                {
                    title: "Enterprise self service",
                    uri: 'enterprise-self-service',
                    foreground: { component: () => import("@/demo/components/CommentOverlay.vue") },
                    slides: [
                        {
                            title: "Enterprise self service",
                            uri: 'use-case',
                            // links: [{ title: 'Overlay', overlay: 'overlay-1' }],
                            keyframes: [
                                {
                                    uri: '01',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_01.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_01.jpg"), continueOnEnd: false } },
                                },{
                                    uri: '02',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_02.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_02.jpg"), continueOnEnd: false } },
                                    comment: 'An AR event is scheduled on the robotics plant due to the VIP team visit. Highest possible bitrate and lowest latency within the network slice is needed for the event to occur.​',
                                },{
                                    uri: '03',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_03.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_03.jpg"), continueOnEnd: false } },
                                    comment: 'The Enterprise’s IT admin configures the AR devices IMSIs within the network slice.',
                                },{
                                    uri: '04',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_04.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_04.jpg"), continueOnEnd: false } },
                                    comment: 'The AR devices are provisioned with the minimum latency and maximum bandwidth parameters the network slice enables.',
                                },{
                                    uri: '05',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_05.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_05.jpg"), continueOnEnd: false } },
                                    comment: 'For a successfull AR visit event it was needed to maintaing high bandwith and low latency for all AR equimpent. AR site visit is concluded without compromission on quality of AR experience.',
                                },{
                                    uri: '06',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_06.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_06.jpg"), continueOnEnd: false } },
                                    comment: 'Once the event concluded, the original parameters are restored.',
                                },{
                                    uri: '07',
                                    content: { video: { src: require("@/demo/assets/videos/usecase-3/usecase_enterprise_07.mp4"), poster: require("@/demo/assets/images/poster/usecase-3/usecase_enterprise_07.jpg"), continueOnEnd: false } },
                                }
                            ],
                        },
                    ]
                },
            ]
        }
    ]
}

export default structure